"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPrevPeriodData = exports.getPeriodData = void 0;
const permissions_1 = require("shared/permissions");
const endpoint_1 = require("api/endpoint");
exports.getPeriodData = endpoint_1.createEndpoint()({
    method: "post",
    path: "financials/data",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});
exports.getPrevPeriodData = endpoint_1.createEndpoint()({
    method: "post",
    path: "financials/prevdata",
    permissions: permissions_1.PERMISSIONS.DISPENSIFY
});



//////////////////
// WEBPACK FOOTER
// ./src/api/financials/financials-client.ts
// module id = 984
// module chunks = 0 1 2